<template>
    <div class="c-target-list__select">
        <v-custom-select v-model="TargetSelected"
                         :options="TargetOptions"
                         search-label="TargetName"
                         option-name="TargetName"
                         option-value="TargetId"
                         track-by="TargetId"
                         :fluid="true"
                         :multiple="true"
                         @updated-selected-options="updateSelected">
            <slot slot="label">{{ $t('preorder_fiche.target_list.compare') }}</slot>
            <div class="c-picked" slot="suffix" v-if="TargetSelected.length > 0">
                <v-target-option
                        v-for="item in TargetSelected"
                        :item="item"
                        :key="item.Id"
                        option-name="TargetName"
                        @default-change="handleDefaultState"
                        @remove="removeItemFromSelected"
                ></v-target-option>
            </div>
        </v-custom-select>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VTargetOption from '@/components/form/targetList/TargetOption'

    // Store
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VCustomSelect,
            VTargetOption,
        },
        computed: {
            ...mapGetters({
                TargetOptions: 'TargetOptions'
            }),
            TargetSelected: {
                get () {
                    return this.$store.getters.TargetSelected;
                },
                set (value) {
                    this.$store.dispatch("setTargetOptions", value)
                }
            }
        },
        created () {
            this.$store.dispatch('getTargetOptions');
        },
        watch:{
            TargetSelected(){
                // If selected targets change and there is no default selected, set the first item as default.
                if(!this.hasDefaults() && this.TargetSelected.length > 0){
                    this.$set(this.TargetSelected[0], 'IsDefault', true);
                }

                // Emit input
                this.$emit('input', this.TargetSelected);
            }
        },
        methods: {
            handleDefaultState (defaultItem) {
                this.TargetSelected.forEach((item, index) => {
                    if (item.TargetId !== defaultItem.TargetId) {
                        this.$set(this.TargetSelected[index], 'IsDefault', false);
                    }
                });

                // Emit input
                this.$emit('input', this.TargetSelected);
            },
            updateSelected (values) {
                // Update data with new selected values
                this.TargetSelected = values;

                // Set first item that has been added as default
                if (this.TargetSelected.length === 1) {
                    this.$set(this.TargetSelected[0], 'IsDefault', true);
                }
            },
            hasDefaults(){
                return this.TargetSelected.find(item => item['IsDefault'] === true);
            },
            removeItemFromSelected (item) {
                const index = this.TargetSelected.indexOf(item);
                this.TargetSelected.splice(index, 1);
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-picked {
        border: 1px solid palette(color-neutral, medium);
        border-top: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/form/targetList/TargetListSelect.vue